import { render, staticRenderFns } from "./spotmarktOrderSplitForm.html?vue&type=template&id=4f2ee316&scoped=true&"
import script from "./spotmarktOrderSplitForm.ts?vue&type=script&lang=ts&"
export * from "./spotmarktOrderSplitForm.ts?vue&type=script&lang=ts&"
import style0 from "./spotmarktOrderSplitForm.scss?vue&type=style&index=0&id=4f2ee316&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ee316",
  null
  
)

/* custom blocks */
import block0 from "./spotmarktOrderSplitForm.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fspotmarkt%2FspotmarktOrderSplitForm%2FspotmarktOrderSplitForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDataIterator,VRow,VTextField})
